import { useEffect, useState } from "react";
import { aiConfigService } from "../services/api/aiConfigService";
import { AI_SERVICE_CODES, AI_CONFIG_CODES } from "../constant/index";
import { hasActiveAiService } from "../utils/helper";

/**
 * Custom hook to manage region detection features
 * @param {Object} item - Camera item
 * @param {number} refreshCamera - Refresh trigger
 * @returns {Object} - Region detection state
 */
export const useRegionDetection = (item, refreshCamera) => {
    const [showModalRegion, setShowModalRegion] = useState({
        show: false,
        region: [],
    });

    // Get parameter setting for region display
    const getParamSettingRegion = async (code, cameraCode) => {
        try {
            const param = {
                codeService: code,
                cameraCode: cameraCode,
            };
            const res = await aiConfigService.get(param);
            const checkShow = res?.find((item) => item?.CODE === AI_CONFIG_CODES.SHOW_REGION)?.VALUE === "1";
            setShowModalRegion((pre) => ({ ...pre, show: checkShow }));
        } catch (error) {
            throw error;
        }
    };

    // Check if common object detection is enabled and load region data
    useEffect(() => {
        const check = hasActiveAiService(item, AI_SERVICE_CODES.COMMON_OBJECT_DETECTION);

        if (check) {
            getParamSettingRegion(AI_SERVICE_CODES.COMMON_OBJECT_DETECTION, item?.code);
        }
    }, [item, refreshCamera]);

    return showModalRegion;
};

